import React from 'react';
import Well from '$components/ProductDashboard/Well';
import styles from './styles.scss';

const achievableSrc = 'https://d31dt0mxu5que4.cloudfront.net/logo-black-with-text.png';
const screenshotSrc =
  'https://d31dt0mxu5que4.cloudfront.net/achievable/achievable-large-hero-finra-series-7.png';

const EnrollLayout = (props) => {
  const { children, organization } = props;
  const { logoHref, tagline } = organization;

  return (
    <div className={styles.layout}>
      <Well>
        <div className={styles.header}>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a href="https://achievable.me/#a_aid=enrollment_header" target="_blank">
            <img src={achievableSrc} className={styles.achievableLogo} />
          </a>
        </div>
        <div className={styles.content}>
          <div className={styles.main}>
            <div className={styles.welcome}>Welcome</div>
            <img src={logoHref} className={styles.partnerLogo} />
            <div className={styles.info}>{tagline}</div>
          </div>
          <img src={screenshotSrc} className={styles.screenshot} />
        </div>
      </Well>
      {children}
    </div>
  );
};

export default EnrollLayout;
